exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content-image{\n  width: 65%;\n  height: auto;\n  border-radius: 15px;\n}\n", ""]);

// exports
